import {
  getDonationTPApi,
  deleteDonationTPApi,
} from "../api/DonationTypePurpose";
import { fetchPurposeApi } from "../api/PurposeType"
import { fetchDonationTypeApi } from "../api/DonationTypes";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DeleteItem from "./DeleteItem";
import SideModal from "../../Components/general/Sidemodal";
import { DonationTypePurposeForm } from "./DonationTypePurposeForm";

interface DonationTypePurposeInterface {
  donationType: string;
  donationTypeId: string;
  donationPurposeId: string;
  donationPurpose: string;
}

interface NewPurpose {
  id: number;
  name: string;
}
interface NewPurpose {
  id: number;
  name: string;
}
interface DonationTypeProps {
  url: string;
}

export const DonationTypePurpose = ({ url }: DonationTypeProps) => {
  const [search, setSearch] = useState("");
  const [donationTP, setDonationTP] = useState<DonationTypePurposeInterface[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{ donationTypeId: string; donationPurposeId: string } | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const totalPages = Math.ceil(donationTP.length / ITEMS_PER_PAGE);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [donationTPResponse] =
        await Promise.all([
          getDonationTPApi("donationTPId", url),
        ]);
      setDonationTP(donationTPResponse);
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
  }

  const handleAddClick = () => {
    setIsAddModalOpen(true);
  };

  const handleDeleteClick = (donationTypeId: string, donationPurposeId: string) => {
    setSelectedItem({ donationTypeId, donationPurposeId });
    setIsModalOpen(true);
  };


  const confirmDelete = async () => {
    if (!selectedItem) return;

    try {
      await deleteDonationTPApi(selectedItem.donationTypeId, selectedItem.donationPurposeId, url);
      setDonationTP((prev) => prev.filter((item) => !(item.donationTypeId === selectedItem.donationTypeId && item.donationPurposeId === selectedItem.donationPurposeId)));
      toast.success("Deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete.");
    } finally {
      setIsModalOpen(false);
      setSelectedItem(null);
    }
  };


  const currentExpenses = donationTP.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );



  return (
    <div className=" h-full px-2 md:px-4 bg-[#ffff]">


      <div className='flex flex-row items-center  '>
        <h2 className="text-3xl font-bold text-blue-600 mt-6 mb-4">
          Donation Type Purpose
        </h2>

        <button
          type="button"
          className=" w-fit px-3 py-2 mx-3 mt-6 mb-4  tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
          onClick={handleAddClick}
        >
          <FaPlus className="w-3 h-3" />
        </button>
      </div>
      <input
        type="text"
        placeholder="Search Donation Type Purpose"
        className="w-full mb-4 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500 border-gray-300"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="flex-grow ml-0 mt-4 w-full">
        <div className="overflow-hidden border border-gray-200 md:rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                >
                  Action
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                >
                  <span>Type</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                >
                  <span>Purpose</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentExpenses.map((donationTP) => (
                <tr key={`${donationTP.donationTypeId}-${donationTP.donationPurposeId}`}>

                  <td className="px-4 py-4 text-sm whitespace-nowrap">
                    <div className="flex items-center gap-x-6">
                      <button
                        onClick={() => handleDeleteClick(donationTP.donationTypeId, donationTP.donationPurposeId)}
                        className="text-gray-500 transition-colors duration-200 dark:hover:text-red-600 dark:text-gray-300 hover:text-red-500 focus:outline-none"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-5 h-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                  <td className="px-4 py-4 text-sm font-medium text-gray-500">
                    {donationTP.donationType}
                  </td>
                  <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {donationTP.donationPurpose}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>


      <div className="flex items-center justify-between mt-6">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-5 h-5 rtl:-scale-x-100"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            />
          </svg>
          <span>Previous</span>
        </button>

        <div className="items-center hidden lg:flex gap-x-3">
          {Array.from({ length: Math.min(10, totalPages) }, (_, index) => {
            const startPage = Math.max(1, currentPage - 5);
            const page = startPage + index;

            if (page > totalPages) return null;

            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-2 py-1 text-sm ${currentPage === page
                  ? "text-blue-500 bg-blue-100"
                  : "text-gray-500 hover:bg-gray-100"
                  } rounded-md`}
              >
                {page}
              </button>
            );
          })}
        </div>

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
        >
          <span>Next</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-5 h-5 rtl:-scale-x-100"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
            />
          </svg>
        </button>
      </div>
      {isModalOpen && (
        <DeleteItem onClose={() => setIsModalOpen(false)} onConfirm={confirmDelete} />
      )}
      <SideModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)}>
        <DonationTypePurposeForm
          onClose={() => setIsAddModalOpen(false)}
          url={url} />
      </SideModal>
    </div>
  );
};
